import CommonDashboardCard from "../commonDashboardCard";

import { Box, CardContent, Stack, Typography } from "@mui/material";
import { FileChartColumn } from 'lucide-react';
import { useIntl } from 'react-intl';

export default function SlaCard({ data }) {
  const intl = useIntl();

  function renderSlaItem(item, index) {
    return (
      <Stack
        key={index}
        direction="row"
        spacing={1}
        alignItems="flex-start"
        sx={{
          gap: 1
        }}
      >
        <Box
          sx={{
            color: item.color,
            mt: 0.25,
            display: 'flex',
          }}
        >
          {item.icon}
        </Box>

        <Box sx={{ minWidth: 0 }}>
          <Typography
            variant="h6"
            fontWeight="bold"
            sx={{
              fontSize: '.8rem',
            }}
          >
            {item.title}
          </Typography>

          <Typography
            variant="h6"
            fontWeight="bold"
            sx={{
              mt: "0.5rem",
              color: '#173663',
              fontSize: '1.7rem',
              lineHeight: 1.15,
            }}
          >
            {item.value}
          </Typography>

          <Typography
            variant="caption"
            sx={{
              display: 'block',
              mt: 0.25,
              fontSize: '.7rem',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            {item.description}
          </Typography>
        </Box>
      </Stack>
    )
  }

  return (
    <CommonDashboardCard
      cardHeaderProps={{
        title: intl.formatMessage({
          id: 'dashboard.new.operation.sla.title',
        }),
        hasDivider: true,
        icon:
          <FileChartColumn
            size={24}
            color="#2fba67"
            absoluteStrokeWidth
          />

      }}
      hasInfo
    >

      <CardContent
        sx={{
          width: '100%',
          boxSizing: 'border-box',
          px: "2rem"
        }}
      >
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 160px), 1fr))',
            alignItems: 'start',
            gap: '2rem',
            width: '100%',
          }}
        >
          {data.map(renderSlaItem)}
        </Box>
      </CardContent>
    </CommonDashboardCard>
  )
}
